import React from 'react';
import Typography from '../Text/Typography';
import './Chip.css';

interface ChipProps {
  label: string;
  isSelected?: boolean;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

const Chip: React.FC<ChipProps> = ({
  label,
  isSelected = false,
  onClick,
  disabled = false,
  className = '',
  style
}) => {
  const getChipClass = () => {
    const baseClass = 'chip';
    const stateClass = isSelected ? 'selected' : '';
    const disabledClass = disabled ? 'disabled' : '';
    
    return `${baseClass} ${stateClass} ${disabledClass} ${className}`.trim();
  };

  return (
    <button
      className={getChipClass()}
      onClick={disabled ? undefined : onClick}
      style={style}
      type="button"
      disabled={disabled}
    >
      <Typography variant="body">
        {label}
      </Typography>
    </button>
  );
};

export default Chip; 